const comments = [
  { name: '星落秋风', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20young%20person%20with%20warm%20coral%20hair%2C%20simple%20illustration%2C%20clean%20background%2C%20flat%20design&width=100&height=100&seq=manwa-avatar-1&orientation=squarish', content: '用了漫蛙三个月了，追更提醒太及时了！以前总是忘记看到哪一话了，现在每周推送准时到，再也不会错过更新。国漫区的内容也越来越丰富了，推荐！', comic: '追更《斗破苍穹》中', time: '2小时前' },
  { name: '墨染青衣', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20with%20dark%20hair%20and%20glasses%2C%20simple%20illustration%2C%20clean%20background%2C%20flat%20design&width=100&height=100&seq=manwa-avatar-2&orientation=squarish', content: '追更列表功能简直是为我这种人量身定做的！同时追20多部漫画，以前全靠脑子记，现在打开漫蛙一目了然。新番开坑指南也超实用，帮我发现了好几部冷门神作。', comic: '追更《间谍过家家》中', time: '5小时前' },
  { name: '浮生若梦', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20with%20blonde%20hair%2C%20simple%20illustration%2C%20clean%20background%2C%20flat%20design&width=100&height=100&seq=manwa-avatar-3&orientation=squarish', content: '日漫经典重温专题做得太好了，把很多童年回忆都找回来了。当年的那些漫画现在重看感受完全不同，漫蛙的专题整理帮了大忙。', comic: '追更《海贼王》中', time: '8小时前' },
  { name: '风起天澜', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20with%20silver%20hair%2C%20simple%20illustration%2C%20clean%20background%2C%20flat%20design&width=100&height=100&seq=manwa-avatar-4&orientation=squarish', content: '漫蛙的热榜真的能反映真实热度，不像某些平台全是刷的。每次看热榜都能发现大家都在追什么，追更社交感满满。希望后面能出个漫友讨论区！', comic: '追更《咒术回战》中', time: '12小时前' },
  { name: '浅夏微凉', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20with%20pink%20hair%2C%20simple%20illustration%2C%20clean%20background%2C%20flat%20design&width=100&height=100&seq=manwa-avatar-5&orientation=squarish', content: '从微博看到推荐过来的，国漫崛起专题太燃了！以前觉得国漫不行，现在发现质量完全不输日漫。漫蛙的国漫精选帮我打开了新世界大门，每部都好好看。', comic: '追更《一人之下》中', time: '1天前' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫友热议
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            来自真实漫画追更用户的评价与分享，看看大家都在追什么
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.slice(0, 3).map((comment, i) => (
            <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
              <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full">{comment.comic}</span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {comments.slice(3, 5).map((comment, i) => (
            <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.content}</p>
              <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full">{comment.comic}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}